export const REGISTRATION_STAGE = "REGISTRATION_STAGE";
export const REGISTRATION_UPDATED_STAGE = "REGISTRATION_UPDATED_STAGE";
export const CLIENT_REGISTRATION_RESTRICTION = "CLIENT_REGISTRATION_RESTRICTION";
export const CLIENT_REGISTRATION = "CLIENT_REGISTRATION";
export const CLIENT_REGISTRATION_POST = "CLIENT_REGISTRATION_POST";
export const CLIENT_INFO = "CLIENT_INFO";
export const CLIENT_DETAILS = "CLIENT_DETAILS";
export const PARTNER_PROPERTIES = "PARTNER_PROPERTIES";